import React from 'react';
import styled from 'styled-components';
import typesTypes from './prop-types';

const Container = styled.div`
  align-items: flex-start;
  margin-right: 20px;
  min-width: 170px;

  & > .header {
    color: ${props => props.theme.secondaryColor};
  }
`;

export default function Types({ types }) {
  return (
    <Container>
      <span className="header">investor type</span>
      {types.map(({ type }) => <span key={type} className="cell">{type}</span>)}
    </Container>
  );
}

Types.propTypes = { types: typesTypes.isRequired };
